export const PREFIX = 'TALK';
export const STATE_NAME = 'talk';

export const LOAD_DATA_START = `${PREFIX}/LOAD_DATA_START`;
export const LOAD_DATA_SUCCESS = `${PREFIX}/LOAD_DATA_SUCCESS`;
export const LOAD_DATA_ERROR = `${PREFIX}/LOAD_DATA_ERROR`;

export const MARK_AS_READ_START = `${PREFIX}/MARK_AS_READ_START`;
export const MARK_AS_READ_DONE = `${PREFIX}/MARK_AS_READ_DONE`;
export const MARK_AS_READ_ERROR = `${PREFIX}/MARK_AS_READ_ERROR`;

export const OFFER = `${PREFIX}/OFFER`;
export const ACCEPT = `${PREFIX}/ACCEPT`;
export const CHARGE_TENANT = `${PREFIX}/CHARGE_TENANT`;
export const CANCEL = `${PREFIX}/CANCEL`;
export const DECLINE = `${PREFIX}/DECLINE`;
export const ANOTHER_DATES = `${PREFIX}/ANOTHER_DATES`;

export const ADD_MESSAGE = `${PREFIX}/ADD_MESSAGE`;
export const READ_MESSAGES = `${PREFIX}/READ_MESSAGES`;
export const UPDATE_CONVERSATION_START = `${PREFIX}/UPDATE_CONVERSATION_START`;
export const UPDATE_CONVERSATION_DONE = `${PREFIX}/UPDATE_CONVERSATION_DONE`;
export const UPDATE_CONVERSATION_FAIL = `${PREFIX}/UPDATE_CONVERSATION_FAIL`;

export const RESET_STATE = `${PREFIX}/RESET_STATE`;
